import {useEffect, useLayoutEffect} from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {


    const { pathname } = useLocation();

    useEffect(() => {
        window.history.scrollRestoration = 'manual';
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    return null;

}

export default ScrollToTop;
